import React, { useCallback } from 'react';
import { MarkRequestReadState, ReadState } from '@atlassian/notification-types/types';
import { triggerActionCtaButtonClicked, useCreateFireAnalyticsFromTrigger } from '../../../utils/analytics';
import { NotificationButton, NotificationButtonDivider } from '../styled';
/**
 * Buttons that appear below notifications as additional calls to action.
 */
var AdditionalCtaButtons = function AdditionalCtaButtons(_ref) {
  var _notification$content, _notification$content2;
  var notification = _ref.notification,
    markBulkNotifications = _ref.markBulkNotifications;
  var fireRequestNotificationCtaClicked = useCreateFireAnalyticsFromTrigger(triggerActionCtaButtonClicked);
  var handleCtaClick = useCallback(function (e, actionAppearance, index) {
    e.stopPropagation();
    fireRequestNotificationCtaClicked(actionAppearance, notification, index);
    var isUnread = notification.readState === ReadState.UNREAD;
    if (isUnread && actionAppearance.toLocaleLowerCase() === 'primary') {
      /**
       * mark notification as read if
       * - it is unread
       * - user clicks "Start free trial"
       */
      markBulkNotifications([notification], MarkRequestReadState.READ);
    }
  }, [notification, fireRequestNotificationCtaClicked, markBulkNotifications]);
  var actions = (_notification$content = notification === null || notification === void 0 || (_notification$content2 = notification.content) === null || _notification$content2 === void 0 ? void 0 : _notification$content2.actions) !== null && _notification$content !== void 0 ? _notification$content : [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, actions.map(function (action, index) {
    var _action$link;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NotificationButton, {
      testId: "additional-cta-".concat(index + 1),
      appearance: "link",
      target: "_blank",
      href: (_action$link = action.link) === null || _action$link === void 0 ? void 0 : _action$link.url,
      onClick: function onClick(e) {
        return handleCtaClick(e, action.appearance, index);
      },
      spacing: "none"
    }, action.title), index < actions.length - 1 && /*#__PURE__*/React.createElement(NotificationButtonDivider, null, "\u22C5"));
  }));
};
export default AdditionalCtaButtons;